<template>
	<DefaultActivity :activity="props.activity" :show-asset="props.showAsset">
		<template #asset-details>
			<p v-if="activity?.redemption_id" class="whitespace-nowrap">ID: {{ activity?.redemption_id }}</p>
			<!--
				Quantity may be omitted by the storefront/item activity feeds when the
				storefront hides ownership data (the same flag that hides owner/token
				counts). Guard with v-if so the row renders cleanly when it's absent.
			-->
			<p v-if="activity?.quantity">Quantity: {{ $format(activity?.quantity) }}</p>
		</template>
		<template #price v-if="activity?.paid">
			Cost: {{ $format(humanReadablePrice(activity?.paid || 0)) }} {{ $token }}
		</template>
		<template #user>@{{ activtyUser(activity) }}</template>
	</DefaultActivity>
</template>

<script lang="ts" setup>
import { AssetActivity } from '@/types/Asset'
import DefaultActivity from './DefaultActivity.vue'
import { humanReadablePrice } from '@/util/currencyFormat'

const props = withDefaults(
	defineProps<{
		activity?: AssetActivity
		showAsset?: boolean
	}>(),
	{
		showAsset: true,
	},
)

function activtyUser(activity: AssetActivity) {
	const { recipient, sender } = activity
	if (recipient) {
		return recipient.username
	} else if (sender) {
		return sender.username
	} else {
		return ''
	}
}
</script>
